module.exports = __webpack_public_path__ + "static/media/example-02.bb01dd45.jpg";